<template>
  <div class="max-w-[1440px] mx-auto leading-relaxed px-5 2xl:px-0">
    <div class="registrierung">
      <div
        class="text-gray-700 mb-4 text-2xl font-bold pb-2 border-b border-primary mt-8"
      >
        Hilfe bei der Registrierung
      </div>
      <AccordionItem
        title="Ich kann mich nicht registrieren / Die Registrierung funktioniert nicht."
        :isOpen="openAccordion === 'reg1'"
        @toggle="toggleAccordion('reg1')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            Sofern Sie bereits eine E-Mail mit einem Einmalpasswort erhalten
            haben oder eine E-Mail mit der Mitteilung, dass Unterlagen im
            Postfach bereitstehen, sind Sie bereits registriert. Bitte gehen Sie
            dann direkt zum Login, um das Portal zu nutzen. Beim erstmaligen
            Login verwenden Sie bitte das Einmalpasswort.
          </li>
          <li>
            Ansonsten prüfen Sie bitte Ihre Eingaben. Achten Sie auf Tippfehler,
            bevor Sie auf „Registrieren“ klicken, und achten Sie bei allen
            Zahleneingaben darauf, dass keine Leerzeichen mit eingegeben wurden.
          </li>
        </ul>
      </AccordionItem>
      <AccordionItem
        title="Ich will mich registrieren. Mir fehlen aber Angaben zur Identifikation / Meine E-Mail funktioniert nicht / Was ist die PID-Nr. oder PM-Nr. und wo finde ich diese?"
        :isOpen="openAccordion === 'reg2'"
        @toggle="toggleAccordion('reg2')"
      >
        <div class="text-gray-700 mb-4 text-lg font-bold">E-Mail</div>
        <ul class="check ml-7 list space-y-4">
          <li>
            Die E-Mail-Adresse sollte die sein, die auch zum Login benutzt
            werden soll.
          </li>
          <li>
            Eine E-Mail-Adresse kann nur einem Nutzer zugeordnet werden; eine
            Doppelnutzung ist nicht möglich.
          </li>
          <li>
            Wenn Sie eine Firmen-Domain nutzen, kann diese blockiert sein.
            Nutzen Sie am besten eine private E-Mail-Adresse. Außer die
            Firmen-E-Mail wird explizit von uns auf unserem Schreiben gefordert.
          </li>
        </ul>
        <div class="text-gray-700 mb-4 text-lg font-bold mt-4">PM-Nr.</div>
        <ul class="check ml-7 list space-y-4">
          <li>
            Es handelt sich um eine interne Nummer, die wir zur Identifizierung
            nutzen. Diese finden Sie in der Regel in unserem Anschreiben im
            Betreff oder innerhalb Ihres Personalschlüssels, „z.B.
            00/1/<b>123456</b>/1“, auf der Pensionsabrechnung. Der Nummernblock
            mit den meisten Ziffern innerhalb Ihres Personalschlüssel ist in der
            Regel die PM-Nr.
          </li>
        </ul>
        <div class="text-gray-700 mb-4 text-lg font-bold mt-4">PID-Nr.</div>
        <ul class="check ml-7 list space-y-4">
          <li>
            Achten Sie darauf, dass diese Nummer im folgenden Format eingegeben
            wird: „PID######“ (für „#“ geben Sie Ihre persönliche PID ein).
          </li>
          <li>
            Sie finden Ihre PID entweder als Anwärter in dem Schreiben, das Sie
            von uns erhalten haben, mit dem Titel „Ihre persönlichen
            Registrierungsdaten“, oder als Rentner im Verwendungszweck Ihrer
            letzten Rentenüberweisung.
          </li>
        </ul>
        <div class="text-gray-700 mb-4 text-lg font-bold mt-4">
          Für Trägerunternehmen
        </div>
        <ul class="check ml-7 list space-y-4">
          <li>
            Sie müssen sich nicht selbst registrieren. Sie sollten die
            Anmeldedaten bereits in einer E-Mail von uns erhalten haben. Falls
            nicht, melden Sie sich bitte bei dem Ihnen bekannten, zuständigen
            Sachbearbeiter oder unter serviceportal@pensus.de. Bitte prüfen Sie
            auch, ob die E-Mail mit den Anmeldedaten in Ihren Spam-Ordner
            verschoben wurde.
          </li>
        </ul>
      </AccordionItem>
    </div>
    <div class="anmeldung" v-if="$route.name == 'login'">
      <div
        class="text-gray-700 mb-4 text-2xl font-bold pb-2 border-b border-primary mt-8 lg:mt-5 xl:mt-8"
      >
        Hilfe bei der Anmeldung
      </div>

      <AccordionItem
        title="Mein bisheriges Passwort funktioniert nicht."
        :isOpen="openAccordion === 'anmeldung'"
        @toggle="toggleAccordion('anmeldung')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            Waren Sie zuletzt 2023 im Service-Portal eingeloggt? Wenn ja: Zu
            diesem Zeitpunkt haben wir unser Serviceportal umgestellt. Sie
            sollten zur selben Zeit eine E-Mail mit einem neuen Einmalpasswort
            erhalten haben. Bitte verwenden Sie dieses für den ersten Login.
          </li>
          <li>
            Falls Sie diese E-Mail nicht mehr haben, können Sie über die
            Funktion „<router-link to="/PasswortVergessen"
              >Passwort vergessen</router-link
            >“ ein neues Passwort anfordern.
          </li>
        </ul>
      </AccordionItem>

      <AccordionItem
        title="Die Website erscheint grau überlagert und ich kann nichts anklicken."
        :isOpen="openAccordion === 'website_grau'"
        @toggle="toggleAccordion('website_grau')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            Im Normalfall erscheint diese Überlagerung zusammen mit einem
            Pop-up-Fenster, das Sie über unsere Cookie-Nutzung informiert.
          </li>
          <li>
            Prüfen Sie, ob sich das Pop-up in einem anderen Fenster geöffnet
            hat. Falls nicht, prüfen Sie bitte, ob Sie einen Adblocker oder ein
            Browser-Add-on nutzen, das dies blockieren kann. Legen Sie in diesem
            Fall eine Ausnahme für unsere Website an und laden Sie die Seite
            neu.
          </li>
        </ul>
      </AccordionItem>

      <AccordionItem
        title="Ich habe bei der Anmeldung alle Daten korrekt eingegeben, die Schaltfläche „Anmelden“ bleibt aber grau. Was muss ich tun?"
        :isOpen="openAccordion === 'button_grau'"
        @toggle="toggleAccordion('button_grau')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            Hier kann es sich um ein Problem mit dem Gültigkeitszeitraum des
            Java Web Tokens handeln. Bitte überprüfen Sie, dass die Uhrzeit
            Ihres Rechners (PC oder mobiles Endgerät) korrekt eingestellt ist.
          </li>
          <li>
            Sollte die Uhrzeit richtig eingestellt sein, drücken Sie bitte
            "Strg" und "F5" oder "Strg" und "Alt" und "E" gleichzeitig auf Ihrer
            Tastatur und geben Sie die Anmeldedaten erneut ein.
          </li>
        </ul>
      </AccordionItem>

      <AccordionItem
        title="Die Anmeldung funktioniert nicht. Die Fehlermeldung „Zugangsdaten sind nicht korrekt“ erscheint."
        :isOpen="openAccordion === 'zugangsdaten_falsch'"
        @toggle="toggleAccordion('zugangsdaten_falsch')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            Laden Sie die Seite vor den folgenden Schritten durch gleichzeitiges
            Drücken der Tasten "Strg" und "F5" neu, löschen Sie die
            Browser-Cookies oder öffnen Sie die Website in einem neuen Browser
            bzw. auf einem anderen Endgerät.
          </li>
          <li>
            Prüfen Sie, ob die eingegebene E-Mail-Adresse wirklich mit der
            E-Mail-Adresse übereinstimmt, an die wir die Mitteilung / das
            Einmalpasswort gesendet haben.
          </li>
          <li>
            Geben Sie das Passwort erneut ein (ggf. mit aktivierter Option
            „Passwort anzeigen“). Prüfen Sie unsichere Stellen genau (z.B. I
            &harr; l).
          </li>
          <li>
            Falls Sie das Passwort in das Feld kopieren, lassen Sie es sich
            anzeigen und klicken Sie anschließend in das Feld hinter das
            Passwort, um sicherzugehen, dass kein Leerzeichen enthalten ist.
            Leerzeichen bitte entfernen.
          </li>
        </ul>
      </AccordionItem>

      <AccordionItem
        title="Ich kann mein Geburtsdatum nicht eingeben."
        :isOpen="openAccordion === 'eingabe_gebdat'"
        @toggle="toggleAccordion('eingabe_gebdat')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            In einigen Fällen (z.B. bei amerikanischem/englischsprachigem System
            oder Browser) kann es vorkommen, dass das standardmäßig verwendete
            Datumsformat von TT/MM/JJJJ auf MM/TT/JJJJ umgestellt wird. Das
            verwendete Format sollte im leeren Geburtsdatumsfeld erkennbar sein.
          </li>
          <li>
            Falls Sie sich für ein Unternehmen einloggen, beachten Sie bitte,
            dass Sie mit Ihrer Passwort-Mail auch ein initiales Geburtsdatum von
            uns erhalten haben. Falls Sie das Geburtsdatum noch nicht geändert
            haben, verwenden Sie dieses.
          </li>
        </ul>
      </AccordionItem>

      <AccordionItem
        title="Ich habe mein Passwort vergessen."
        :isOpen="openAccordion === 'passwort_vergessen'"
        @toggle="toggleAccordion('passwort_vergessen')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            Oben links über dem „Anmelden“-Button befindet sich eine
            Weiterleitung zum Bereich „<router-link to="/PasswortVergessen"
              >Passwort vergessen</router-link
            >“. Geben Sie dort Ihre E-Mail-Adresse und das Geburtsdatum ein
            (prüfen Sie die Eingaben wie zuvor beschrieben).
          </li>
          <li>
            Falls Sie für ein Unternehmen das Passwort zurücksetzen, beachten
            Sie bitte: Sie haben mit Ihrer Passwort-Mail auch ein initiales
            Geburtsdatum erhalten. Falls Sie das Geburtsdatum noch nicht
            geändert haben, verwenden Sie dieses, initiale Geburtsdatum.
          </li>
        </ul>
      </AccordionItem>
      <!-- <AccordionItem
        title="Das Passwort, das ich von Ihnen per E-Mail erhalten habe, funktioniert nicht. Was muss ich tun?"
        :isOpen="openAccordion === 'passwort'"
        @toggle="toggleAccordion('passwort')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>Bitte prüfen Sie erneut die Eingabe.</li>
          <li>
            Fehlerhafte Eingaben müssen ggf. vor einem erneuten Versuch gelöscht
            werden. Dazu bitte Strg+F5 oder Strg+Alt+E gleichzeitig drücken.
          </li>
          <li>
            Bitte verwenden Sie die gleiche E-Mailadresse, an die wir das
            Initialisierungskennwort gesandt haben.
          </li>
          <li>
            Sofern Sie das Passwort kopiert haben, versuchen Sie es bitte erneut
            über eine manuelle Eingabe.
          </li>
          <li>
            Sollten alle vorgenannten Optionen nicht funktionieren, fordern Sie
            bitte über die Funktion „Passwort vergessen“ ein neues Passwort an.
            Sie erhalten dann innerhalb der nächsten 60 Minuten ein neues
            Passwort per E-Mail.
          </li>
        </ul>
      </AccordionItem> -->
      <!-- <AccordionItem
        title="Ich habe bei der Anmeldung alle Daten korrekt eingegeben, die Schaltfläche „Anmelden“ bleibt jedoch grau. Was muss ich tun?"
        :isOpen="openAccordion === 'korrekt'"
        @toggle="toggleAccordion('korrekt')"
      >
        <ul class="check ml-7 list space-y-4">
          <li>
            Hier kann es sich um ein Problem mit dem Gültigkeitszeitraum des
            JavaWebTokens handeln. Bitte überprüfen Sie, dass die Uhrzeit Ihres
            Rechners (PC oder mobiles Endgerät) korrekt eingestellt ist.
          </li>
          <li>
            Sollte die Uhrzeit richtig eingestellt sein, bitte Strg+F5 oder
            Strg+Alt+E gleichzeitig drücken und die Anmeldedaten nochmals
            eingeben.
          </li>
        </ul>
      </AccordionItem> -->
    </div>
    <div class="rechte-seite">
      <div class="wo" v-if="$route.name != 'login'">
        <div
          class="text-gray-700 mb-4 text-2xl font-bold pb-2 border-b border-primary mt-8 lg:mt-5 xl:mt-8"
        >
          Wo finde ich was?
        </div>
        <AccordionItem
          title="Ihre betriebliche Altersversorgung ganz einfach digital verwalten."
          :isOpen="openAccordion === 'wowas'"
          @toggle="toggleAccordion('wowas')"
        >
          <ul class="check ml-7 list space-y-4">
            <li>
              Ihre persönlichen Daten wie Anschrift, Geburtsdatum oder Ihre
              Bankverbindung können Sie unter dem Menüpunkt
              <router-link
                active-class="font-bold"
                to="/persoenlichedaten"
                class=""
              >
                „Meine Daten“
              </router-link>
              einsehen oder bei Bedarf ändern.
            </li>
            <li>
              Unter dem Menüpunkt
              <router-link
                active-class="font-bold"
                to="/versorgungsdaten"
                class=""
              >
                „Meine Versorgung“
              </router-link>
              können Sie alle wesentlichen Informationen rund um Ihre
              betriebliche Altersversorgung abrufen.
            </li>
            <li>
              Wichtige Dokumente wie z.B. Ihre letzte Rentenabrechnung,
              Steuerbescheinigungen oder aktuelle Standmitteilungen können Sie
              ganz bequem unter dem Menüpunkt
              <router-link
                active-class="font-bold"
                to="/versorgungsdokumente"
                class=""
              >
                „Versorgungsdokumente"
              </router-link>
              einsehen und bei Bedarf auf Ihrem elektronischen Endgerät
              speichern.
            </li>
            <li>
              Sie haben ein Anliegen oder Änderungswunsch zu Ihrer Versorgung?
              Unter dem Menüpunkt
              <router-link
                active-class="font-bold"
                to="/auftrag-an-pensus"
                class=""
              >
                „Auftrag an Pensus“
              </router-link>
              finden Sie alle wichtigen Online-Formulare, um direkt mit uns in
              Kontakt zu treten und Aufträge an uns zu übermitteln. Sobald wir
              Ihren Auftrag bearbeitet haben, erhalten Sie eine Nachricht per
              E-Mail sofern Sie uns diese mitgeteilt haben.
            </li>
          </ul>
        </AccordionItem>
      </div>
      <div class="nutzung">
        <div
          class="text-gray-700 mb-4 text-2xl font-bold pb-2 border-b border-primary mt-8"
        >
          Hilfe bei der Nutzung
        </div>

        <AccordionItem
          title="Das heruntergeladene Dokument wird von meinem PDF-Reader nicht als PDF erkannt und lässt sich nicht öffnen."
          :isOpen="openAccordion === 'pdf_öffnen'"
          @toggle="toggleAccordion('pdf_öffnen')"
        >
          Bitte loggen Sie sich aus dem Serviceportal aus und löschen Sie Ihre
          Browser-Cookies. Danach loggen Sie sich erneut ein und wiederholen den
          Download. Das Dokument sollte sich nun öffnen lassen.
        </AccordionItem>

        <AccordionItem
          title="Wo finde ich meine Dokumente? / Das Dokument ist nicht mehr im Postfach."
          :isOpen="openAccordion === 'dokumente_finden'"
          @toggle="toggleAccordion('dokumente_finden')"
        >
          Dokumente im Postfach liegen dort nur für ca. 2 Monate oder bis sie
          das erste Mal geöffnet werden. Danach finden Sie Ihre Dokumente unter
          „Meine Versorgung“ &rarr; „Versorgungsdokumente“.
        </AccordionItem>

        <AccordionItem
          title="Das Dokument, das ich suche, ist in „Versorgungsdokumente“ nicht zu sehen."
          :isOpen="openAccordion === 'dokument_nicht_da'"
          @toggle="toggleAccordion('dokument_nicht_da')"
        >
          <div>
            Die meisten Dokumente bleiben nur für ca. 1 Jahr im Service-Portal
            gespeichert. Wenn das Dokument älter sein sollte, wurde es entfernt.
            Bitte senden Sie uns eine Nachricht über unser Service-Portal, indem
            Sie auf das rote Banner mit dem Stift klicken. In den dortigen
            Feldern tragen Sie bitte Ihre Daten ein. Achten Sie darauf, dass im
            Feld „Ihr Anliegen“ „Fragen zum Portal“ ausgewählt ist und dass Sie
            mitteilen, welche Dokumente Sie von uns benötigen.
          </div>

          <div class="text-gray-700 mb-4 text-lg font-bold mt-4">
            Sind Sie Neurentner?
          </div>
          <ul class="check ml-7 list space-y-4">
            <li>
              Wenn Sie Neurentner sind, kann es sein, dass Ihre Dokumente noch
              nicht generiert wurden. Sobald Dokumente für Sie zur Verfügung
              stehen, erhalten Sie von uns eine Benachrichtigungs-E-Mail.
            </li>
            <li>
              Für bestimmte Leistungen (z.B. Renten, die selbst versteuert
              werden) werden manche Dokumente nicht generiert.
            </li>
          </ul>
        </AccordionItem>

        <AccordionItem
          title="Wenn ich meine Dokumente ausdrucken will, sind Teile geschwärzt."
          :isOpen="openAccordion === 'schwarzer_druck'"
          @toggle="toggleAccordion('schwarzer_druck')"
        >
          Wenn Sie Dokumente mit dem Acrobat Reader öffnen, kann es aufgrund der
          Voreinstellungen dazu kommen, dass vertrauliche Informationen beim
          Ausdrucken automatisiert geschwärzt werden. Bitte ändern Sie die
          Voreinstellungen von Adobe oder öffnen Sie das Dokument vor dem Druck
          im Browser oder mit einer anderen Software.
        </AccordionItem>

        <AccordionItem
          title="Wenn ich einen neuen Auftrag einreichen will, wird mir auf der Startseite folgender Hinweis angezeigt: „Ihre Daten werden aktuell an anderer Stelle bearbeitet“. Was bedeutet das?"
          :isOpen="openAccordion === 'stelle'"
          @toggle="toggleAccordion('stelle')"
        >
          Dieser Hinweis bedeutet, dass Sie einen oder mehrere Änderungsaufträge
          erteilt haben. Sie können während einer Sitzung beliebig viele
          Änderungsaufträge einreichen. Wenn Sie sich dann aber aus dem Portal
          ausloggen, müssen zunächst die eingereichten Aufträge von uns
          bearbeitet werden, bevor Sie im Rahmen einer neuen Sitzung weitere
          Aufträge einreichen. Selbstverständlich können Sie aber bis dahin Ihre
          Daten einsehen und Dokumente downloaden. Sobald die Aufträge
          bearbeitet wurden, erhalten Sie eine Nachricht von uns per E-Mail.
        </AccordionItem>
        <!-- <AccordionItem
          title="In der Rubrik „Meine Versorgung“ werden unter „Versorgungsdokumente“ keine Inhalte angezeigt. Woran liegt das?"
          :isOpen="openAccordion === 'doku'"
          @toggle="toggleAccordion('doku')"
        >
          In diesem Fall sind Sie vermutlich Neurentner oder ein neu
          aufgenommener Anwärter. Dokumente können demzufolge erst dann
          bereitgestellt werden, wenn Sie von uns erzeugt wurden. Naturgemäß
          kann es deshalb zirka 1 bis 2 Monate dauern, bis die ersten Dokumente
          wie Abrechnungen, Kontoauszüge/Standmitteilungen,
          Steuerbescheinigungen etc. abgerufen werden können.
        </AccordionItem> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import AccordionItem from "./FAQAccordion.vue";
/** Akkordeon-Inhalte der FAQ-Seite
 *  @displayName Inhalte FAQ-Seite
 * */
</script>
<script>
export default {
  components: {
    AccordionItem,
  },
  data() {
    return {
      openAccordion: null,
    };
  },
  methods: {
    toggleAccordion(accordionTitle) {
      this.openAccordion =
        this.openAccordion === accordionTitle ? null : accordionTitle;
    },
  },
};
</script>
